export interface RecoverPasswordFormValues {
  email: string;
}

export enum RecoverPasswordFields {
  email = "email",
}
